/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metadata_List_TitleInputs */



/**
* | output |
* | --- |
* | "Project Metadata" |
*
* @param {Options_Metadata_List_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metadata_list_title = /** @type {((inputs?: Options_Metadata_List_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metadata_List_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Métadonnées du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektmetadaten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Metadati del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Метаданные проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Metadatos del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目元数据")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトメタデータ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजना मेटाडेटा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Metadados do projeto")
	return /** @type {LocalizedString} */ ("Project Metadata")
});